import { BookingsLineChart } from './BookingsLineChart';
import { BookingsBarChart } from './BookingsBarChart';
import { STATUS_SERIES, AREA_SERIES } from './constants';
import type { Booking, ChartGroup, ChartType, DateWindow } from './types';

export interface BookingsChartsProps {
  bookings: Booking[];
  chartType: ChartType;
  // Group the breakdown by booking status or by kennel area.
  group: ChartGroup;
  viewWindow: DateWindow;
  // A new range is loading while this one is held on screen — dim to acknowledge.
  pending?: boolean;
  // Page the window by a horizontal drag. The Daily page passes it at the phone
  // tier, where the window is a fortnight rather than a quarter.
  onSwipe?: (dir: 1 | -1) => void;
}

// Charts tab (AC3). The single shared chart, referenced by both the Bookings
// page and the Daily page. `chartType` picks line vs bar; `group` picks the
// status vs area breakdown (resolved to the bands the chart draws). While the
// next range loads, the current chart is held + dimmed (no flash).
export function BookingsCharts({ bookings, chartType, group, viewWindow, pending, onSwipe }: BookingsChartsProps) {
  const bands = group === 'area' ? AREA_SERIES : STATUS_SERIES;
  const title = group === 'area' ? 'Dogs by area, per day' : 'Dogs by status, per day';
  return (
    <div className={'charts-wrap' + (pending ? ' is-pending' : '')}>
      {chartType === 'line' ? (
        <BookingsLineChart bookings={bookings} viewWindow={viewWindow} bands={bands} title={title} onSwipe={onSwipe} />
      ) : (
        <BookingsBarChart bookings={bookings} viewWindow={viewWindow} bands={bands} title={title} onSwipe={onSwipe} />
      )}
    </div>
  );
}
